const AppMenuTab = {
	MARITIME: "Maritime",
	AVIATION: "Aviation",
	ENVIRONMENT: "Environment",
	CUSTOM_DATASETS: "Custom"
};
export default AppMenuTab;
